import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import Vuetify from 'vuetify'
import VueApexCharts from 'vue-apexcharts'
import Notifications from 'vue-notification'
import axiosAPI from './axios/axiosAPI'
import axiosInterceptors from './axios/axiosInterceptors'

// Import Main style files
import 'vuetify/dist/vuetify.min.css'
import './assets/scss/App.scss'

// Import Layouts
import Default from './layouts/default'
import Auth from './layouts/auth'
import AuthSettings from './layouts/authSettings'

// Import Components
import appCard from './components/layout/app-card'
import appBreadcrumb from './components/layout/app-breadcrumb'
import stickyBreadcrumb from './components/layout/sticky-breadcrumb'
import iTextField from './components/ui/text-field'
import iList from './components/ui/list/list'
import iListItem from './components/ui/list/list-item'
import iBtn from './components/ui/button'
import iCheckbox from './components/ui/checkbox'
import iSwitch from './components/ui/switch'
import iSpinner from './components/elements/materialSpinner'
import iRadioSwitch from './components/elements/radioSwitch'
import iRadioGroup from './components/elements/radioGroup'
import iNoResults from './components/layout/noResults'
import iNoData from './components/layout/noData'
import iSuccess from './components/elements/success'

// Use Layouts
Vue.component('default-layout', Default)
Vue.component('auth-layout', Auth)
Vue.component('authSettings-layout', AuthSettings)

// Use Components
Vue.component('apexchart', VueApexCharts)
Vue.component('app-card', appCard)
Vue.component('app-breadcrumb', appBreadcrumb)
Vue.component('sticky-breadcrumb', stickyBreadcrumb)
Vue.component('i-text-field', iTextField)
Vue.component('i-list', iList)
Vue.component('i-list-item', iListItem)
Vue.component('i-btn', iBtn)
Vue.component('i-checkbox', iCheckbox)
Vue.component('i-switch', iSwitch)
Vue.component('i-spinner', iSpinner)
Vue.component('i-radio-switch', iRadioSwitch)
Vue.component('i-radio-group', iRadioGroup)
Vue.component('i-no-results', iNoResults)
Vue.component('i-no-data', iNoData)
Vue.component('i-success', iSuccess)

Vue.config.productionTip = false
Vue.use(Vuetify, {
  theme: {
    primary: '#307fff',
    secondary: '#498fff',
    error: '#ea5455',
    success: '#27c76e'
  }
})
Vue.use(VueApexCharts)
Vue.use(Notifications)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axiosAPI,
  axiosInterceptors,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js